"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  //Distance calculator for locations based on browser geolocation
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(updateNavigationLocations);
  }
  function updateNavigationLocations(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    if (lat && lng) {
      document.querySelectorAll(".location-menu").forEach(function (menu) {
        requestNavigationLocations(menu, lat, lng);
      });
    }
  }
  function requestNavigationLocations(menu, lat, lng) {
    var columnId = menu.getAttribute("data-column-id");
    fetch('/api/sitecore/navigation/locations?ColumnId=' + columnId + '&lat=' + lat + '&lon=' + lng, {
      method: 'get'
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      return processNavigationLocationsData(data, menu);
    }).catch(function (err) {
      //Maybe TODO
    });
  }
  function processNavigationLocationsData(data, menu) {
    var list = menu.querySelector(".locations-list");
    var html = "";
    data.Locations.forEach(function (loc) {
      html += '<li><a href="' + loc.Url + '">' + loc.Name + '</a></li>';
    });
    list.innerHTML = html;
    var title = menu.querySelector(".location-title");
    var titleText = title.getAttribute("data-location-title");
    title.innerHTML = titleText;
  }
});